import { FC } from "react";
import { faShieldHalved } from "@fortawesome/pro-solid-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import { Anchor, MantineStyleProps, Text } from "@mantine/core";

import { HoverTooltip } from "@shared/components";

interface SecureDefaultInfoProps {
  fz?: MantineStyleProps["fz"];
  c?: MantineStyleProps["c"];
  newLabelFz?: MantineStyleProps["fz"];
  iconSize?: FontAwesomeIconProps["size"];
}

/**
 * Component that displays a shield icon and a "Secure default" label with a "New" label.
 *
 * @param fz font size of the text
 * @param c color of the text
 * @param newLabelFz font size of the "New" label
 * @param iconSize size of the shield icon
 */
export const SecureDefaultInfo: FC<SecureDefaultInfoProps> = ({
  fz,
  c,
  newLabelFz = "0.7em",
  iconSize,
}) => {
  return (
    <HoverTooltip
      content={
        <Anchor
          href={
            "https://semgrep.dev/docs/secure-guardrails/secure-guardrails-in-semgrep?utm_source=app&utm_medium=product&utm_campaign=2024-q2-secure-guardrails"
          }
          target="_blank"
          rel="noopener noreferrer"
          underline="always"
          c="white"
          inherit
        >
          Learn more about secure defaults
        </Anchor>
      }
    >
      <Text c="gray.7" fz={fz}>
        <Text inherit span mr="8px" display="inline-block">
          <FontAwesomeIcon icon={faShieldHalved} size={iconSize} />
        </Text>

        <Text inherit span c={c}>
          Secure default{" "}
          <Text
            component="sup"
            span
            fz={newLabelFz}
            tt="uppercase"
            c="green"
            fw={700}
          >
            New
          </Text>
        </Text>
      </Text>
    </HoverTooltip>
  );
};
